export default __webpack_public_path__ + "static/media/seiseki3.508bafd5.png";